module.exports = window["Bernie_l10nBundle_th_TH"];